import React from "react";
import { AIRPORTS_URL, renderLink } from "../../search/result/renderers";

interface ScheduleStopsDisplayProps {
	stops?: number | string;
	codes?: string[];
}

export const ScheduleStopsDisplay = ({
	stops,
	codes,
}: ScheduleStopsDisplayProps) => {
	return (
		<span className="flex">
			{stops}
			{codes.map((code, idx) => (
				<div key={idx}>
					/{renderLink(`${AIRPORTS_URL}${code}`, code)}
				</div>
			))}
		</span>
	);
};
